import { render, staticRenderFns } from "./Compartir.vue?vue&type=template&id=68446f40&scoped=true&"
import script from "./Compartir.vue?vue&type=script&lang=js&"
export * from "./Compartir.vue?vue&type=script&lang=js&"
import style0 from "./Compartir.vue?vue&type=style&index=0&id=68446f40&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68446f40",
  null
  
)

export default component.exports